import React from 'react'
import { useAppDispatch, useAppSelector } from 'reduxTyped'
import { l } from '@manychat/manyui'

import { openIgPreviewModal, removeNotification } from 'common/core/actions/uiActions'
import { getUI } from 'common/core/selectors/uiSelectors'
import { analyticsService } from 'utils/services/analytics'

export const IgPreviewHowTo = ({ keyword }: { keyword?: string }) => {
  const ui = useAppSelector(getUI)
  const dispatch = useAppDispatch()
  const showIgPreviewModal = () => {
    const notificationId = ui.notifications.find(
      (notification) => notification.source === 'previewSuccessAlert',
    )?.id

    notificationId && dispatch(removeNotification(notificationId))
    dispatch(openIgPreviewModal(keyword))

    analyticsService.sendEvent('PREVIEW_INSTAGRAM_MODAL.SHOWN', {
      isFirstTime: false,
    })
  }

  return (
    <div onClick={showIgPreviewModal} className="text-body text-primary c-pointer m-t m-b-xs">
      {l.translate('How to preview an IG Automation?')}
    </div>
  )
}
